import { IndexedObject } from "@themuse/design-system";

export interface Location extends IndexedObject {
    label: string;
    latitude: number;
    longitude: number;
    remote_work_location_type?: string; // eslint-disable-line camelcase
    value: string;
}

export interface SearchLocation {
    userInputValue?: string;
    userSelectedLocation?: Location;
    locationSuggestions?: Location[];
}

export interface Company extends IndexedObject {
    label: string;
    value: string;
}

export interface SearchCompany {
    userInputValue?: string;
    userSelectedCompany?: Company;
    companySuggestions?: Company[];
}

export interface SearchKeyword {
    userInputValue?: string;
    userSelectedKeyword?: IndexedObject;
}

export interface JobTileInteractions {
    /* job IDs of tiles the user has viewed */
    tilesViewedJobIds?: string[];
}

export interface FilterInteractions {
    /* when individual filter was cleared */
    individualFilterClearedAt?: number;

    /* when filter clear all was clicked on desktop */
    desktopClearAllClickedAt?: number;

    /* when filter clear all was clicked on mobile */
    mobileClearAllClickedAt?: number;

    /* when search button was clicked */
    searchButtonClickedAt?: number;
}

export interface UserInteractions extends JobTileInteractions, FilterInteractions {}

export interface SearchFilters {
    category?: string[];
    industry?: string[];
    experienceLevel?: string[];
    perks?: string[];
    companySize?: string[];
    radius?: string;
    postedDateRange?: string;
    companyLeadership?: string[]
    location?: string[];
    company?: string[];
}

export interface WindowLocation {
    hash: string;
    host: string;
    hostname: string;
    href: string;
    origin: string;
    pathname: string;
    port: string;
    protocol: string;
    search: string;
}

export interface SearchState {
    location?: SearchLocation;
    company?: SearchCompany;
    keyword?: SearchKeyword;
    filters?: SearchFilters;
    userInteractions?: UserInteractions;
    url?: string;
    windowLocation?: WindowLocation;
    preference?: string;
    searchId?: string;
    ctsEnabled: boolean;
}

export enum LocationActionTypes {
    updateLocation = "update_location",
    updateLocationSuggestions = "update_location_suggestions",
    resetLocation = "reset_location"
}

export interface LocationAction {
    type: LocationActionTypes;
    payload?: SearchLocation;
}

export enum CompanyActionTypes {
    updateCompany = "update_company",
    updateCompanySuggestions = "update_company_suggestions",
    resetCompany = "reset_company"
}

export interface CompanyAction {
    type: CompanyActionTypes;
    payload?: SearchCompany;
}

export enum FiltersActionTypes {
    updateFilter = "update_filter",
    resetAllFilters = "reset_all_filters"
}

export interface FiltersAction {
    type: FiltersActionTypes;
    payload?: SearchFilters;
}

export enum KeywordActionTypes {
    updateKeyword = "update_keyword",
    resetKeyword = "reset_keyword"
}

export interface KeywordAction {
    type: KeywordActionTypes;
    payload?: SearchKeyword;
}

export enum UserInteractionActionTypes {
    updateJobTileViews = "update_job_tile_views",
    updateFilterInteraction = "update_filter_interaction",
    resetJobTileViews = "reset_job_tile_views"
}

export interface UserInteractionAction {
    type: UserInteractionActionTypes;
    payload?: UserInteractions;
}

export enum UrlActionTypes {
    updateUrl = "update_url"
}

export interface UrlAction {
    type: UrlActionTypes;
    payload: string;
}

export enum WindowLocationActionTypes {
    updateWindowLocation = "update_window_location"
}

export interface WindowLocationAction {
    type: WindowLocationActionTypes;
    payload: WindowLocation;
}

export enum SearchIdActionTypes {
    updateSearchId = "update_search_id"
}

export interface SearchIdAction {
    type: SearchIdActionTypes;
    payload: string;
}

export interface SearchDispatch {
    (action:
        LocationAction |
         CompanyAction |
         KeywordAction |
         FiltersAction |
 UserInteractionAction |
             UrlAction |
  WindowLocationAction |
        SearchIdAction
      ): void;
}
